"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Area = void 0;
var cache_1 = require("@timeflies/cache");
var common_1 = require("@timeflies/common");
var bresenham_1 = __importDefault(require("bresenham"));
var easystarjs_1 = __importDefault(require("easystarjs"));
var tile_1 = require("./tile");
var Area;
(function (Area) {
    Area.getMapGrid = function (tiledMap) {
        var grid = {};
        for (var y = 0; y < tiledMap.height; y++) {
            for (var x = 0; x < tiledMap.width; x++) {
                var p = common_1.createPosition(x, y);
                var tileType = tile_1.Tile.getTileTypeFromPosition(p, tiledMap);
                grid[p.id] = __assign(__assign({}, p), { tileType: tileType });
            }
        }
        return grid;
    };
    Area.getArea = function (center, r, tiledMap) {
        var area = [];
        var sum = 0;
        for (var i = 0; i <= r * 2; i++) {
            for (var k = 0; k <= (i - sum) * 2; k++) {
                var pos = common_1.createPosition(center.x - i + sum + k, center.y - r + i);
                if (tile_1.Tile.getTileTypeFromPosition(pos, tiledMap) === 'default') {
                    area.push(pos);
                }
            }
            if (i >= r) {
                sum += 2;
            }
        }
        return area;
    };
    Area.getBresenhamLine = function (start, end, tiledMap) {
        var path = bresenham_1.default(start.x, start.y, end.x, end.y);
        return path
            .map(function (_a) {
            var x = _a.x, y = _a.y;
            return common_1.createPosition(x, y);
        })
            .map(function (position) { return ({
            position: position,
            tileType: tile_1.Tile.getTileTypeFromPosition(position, tiledMap)
        }); });
    };
    Area.getPathfinderInstance = function () {
        var pathfinder = new easystarjs_1.default.js();
        var acceptableTiles = [0];
        // cache grid calculation
        var gridCache = cache_1.createCache();
        var computePathfinderGrid = function (tiledMap, characterAliveList, charactersPositions) {
            var characterPositionsSet = new Set(characterAliveList.map(function (characterId) { return charactersPositions[characterId].id; }));
            var getTileID = function (p) {
                var obstacle = tile_1.Tile.getTileTypeFromPosition(p, tiledMap) === 'obstacle'
                    || characterPositionsSet.has(p.id);
                return obstacle ? 1 : acceptableTiles[0];
            };
            var pathfinderGrid = [];
            for (var y = 0; y < tiledMap.height; y++) {
                pathfinderGrid[y] = [];
                for (var x = 0; x < tiledMap.width; x++) {
                    var p = common_1.createPosition(x, y);
                    pathfinderGrid[y][x] = getTileID(p);
                }
            }
            return pathfinderGrid;
        };
        var refreshGridIfNeeded = function (tiledMap, characterAliveList, charactersPositions) {
            gridCache.getOrElse(charactersPositions, function () {
                gridCache.clear();
                pathfinder.setGrid(computePathfinderGrid(tiledMap, characterAliveList, charactersPositions));
                pathfinder.setAcceptableTiles(acceptableTiles);
                return null;
            });
        };
        var calculatePath = function (tiledMap, characterAliveList, charactersPositions, _a, _b) {
            var startX = _a.x, startY = _a.y;
            var endX = _b.x, endY = _b.y;
            return new Promise(function (resolve) {
                refreshGridIfNeeded(tiledMap, characterAliveList, charactersPositions);
                pathfinder.findPath(startX, startY, endX, endY, function (path) {
                    resolve((path !== null && path !== void 0 ? path : []).map(function (_a) {
                        var x = _a.x, y = _a.y;
                        return common_1.createPosition(x, y);
                    }));
                });
                pathfinder.calculate();
            });
        };
        return {
            calculatePath: calculatePath
        };
    };
})(Area = exports.Area || (exports.Area = {}));
